<template>
    <div class="">
      <div class="form-box">
          <el-form inline :model="formData" size="mini" ref="form">
              <el-form-item prop="resultData">
                  <CustomInput @append-click="handleGenAppendClick">
                      <template #prepend>
                          <ESelect 
                              style="width:100px" 
                              v-model="formData.genType" 
                              slot="prepend" 
                              placeholder="请选择"
                              @change="()=>formData.resultData=[]"
                          >
                              <el-option 
                                  v-for="item in genTypeList" 
                                  :key="item.value"
                                  :label="item.label" 
                                  :value="item.value"
                              />
                          </ESelect>
                      </template>
                      <ESelect  
                          v-model="formData.resultData" 
                          filterable 
                          clearable 
                          style="width:200px" 
                          placeholder="请输入关键字搜索"
                          multiple
                          collapse-tags
                          remote
                          reserve-keyword
                          :loading="searchLoading"
                          :remote-method="appEntrySearchList"
                          ref="select"
                      >
                          <p class="option-select">
                              <el-button type="text" @click="()=>handleSelectAll(resultDataList)">全选</el-button>
                              <el-button type="text" @click="()=>formData.resultData=[]">取消全选</el-button>
                          </p>
                          <el-option 
                              v-for="item in resultDataList"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                              style="width:210px"
                          />
                      </ESelect>
                      <template #append>
                          <i class="el-icon-document-copy"/>
                      </template>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="appType">
                  <CustomInput label='产品类型'>
                      <ESelect  style="width:120px"  v-model="formData.appType" clearable placeholder="请选择">
                          <el-option 
                              v-for="item in dictData.app_type"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="packageType">
                  <CustomInput label='包体类型'>
                      <ESelect style="width:180px" v-model="formData.packageType" multiple collapse-tags clearable placeholder="请选择">
                          <p class="option-select">
                              <el-button 
                                  type="text" 
                                  @click="handleAllPackageType"
                              >
                                  全选
                              </el-button>
                              <el-button type="text" @click="()=>formData.packageType = []">取消全选</el-button>
                          </p>
                         <el-option 
                              v-for="item in dictData.package_type"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="gameType">
                  <CustomInput label='游戏分类'>
                      <ESelect style="width:120px" v-model="formData.gameType" clearable placeholder="请选择">
                          <el-option 
                              v-for="item in dictData.game_classify"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="platId">
                  <CustomInput label='媒体'>
                      <ESelect style="width:180px" collapse-tags v-model="formData.platId" filterable multiple clearable placeholder="请选择">
                          <el-option 
                              v-for="item in dictData.plat_id"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="auth">
                  <CustomInput label='认证情况'>
                      <ESelect style="width:120px" v-model="formData.auth" clearable placeholder="请选择">
                          <el-option 
                              v-for="item in dictData.is_auth"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
               <el-form-item prop="ascription">
                  <CustomInput label='归属客户'>
                      <el-input style="width:140px" placeholder="请输入关键词搜索" clearable  v-model="formData.ascription">
                      </el-input>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="creator">
                  <CustomInput label='创建人'>
                      <ESelect  
                          v-model="formData.creator" 
                          :filter-method="handleFilterMethod" 
                          reserve-keyword 
                          filterable 
                          multiple 
                          clearable 
                          collapse-tags
                          style="width:180px"
                          placeholder="请选择"
                      >
                          <p class="option-select">
                              <el-button 
                                  type="text" 
                                  @click="handleAllCreator"
                              >
                                  全选
                              </el-button>
                              <el-button type="text" @click="()=>formData.creator = []">取消全选</el-button>
                          </p>
                          <el-option 
                              v-for="item in filterCreatorList"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="creatorDep">
                  <CustomInput label='创建人部门'>
                      <el-cascader
                          v-model="formData.creatorDep"
                          ref="cascader"
                          clearable
                          collapse-tags
                           style="width:230px"
                          placeholder="请选择"
                          :show-all-levels="false"
                          :options="creatorDepOptions"
                          :props="{ multiple: true }"
                          @change="onCascaderChange"
                          filterable/>
                  </CustomInput>
              </el-form-item>
              <el-form-item prop="date">
                  <CustomInput label='创建时间'>
                      <el-date-picker
                          v-model="formData.date"
                          style="width:240px"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          prefix-icon=""
                          clearable
                          value-format="yyyy-MM-dd"
                          end-placeholder="结束日期">
                      </el-date-picker>
                  </CustomInput>
              </el-form-item>
  
              <el-form-item :prop="formListItem.name" v-for="(formListItem, index) in formList" :key="index">
                  <CustomInput :label='formListItem.display_name'>
                      <ESelect style="width:180px" v-model="formData.other[formListItem.name]" filterable multiple collapse-tags clearable placeholder="请选择">
                          <p class="option-select">
                              <el-button 
                                  type="text" 
                                  @click="handleSelectAllNew(formListItem.option, formListItem.name)"
                              >
                                  全选
                              </el-button>
                              <el-button type="text" @click="()=>formData.other[formListItem.name] = []">取消全选</el-button>
                          </p>
                         <el-option 
                              v-for="item in formListItem.option"
                              :key="item.value"
                              :label="item.label" 
                              :value="item.value"
                          />
                      </ESelect>
                  </CustomInput>
              </el-form-item>
          </el-form>
          <div class="opts">
              <el-button type="primary" :loading="loading" size="mini" @click="()=>getList()">查询</el-button>
              <el-button size="mini" @click="handleClear">清空筛选</el-button>
          </div>
      </div>
      <div class="table-context" v-loading="loading">
          <el-button v-if="pageFuncNames.includes('add_app')" class="ml10 mb10" type="primary" icon="el-icon-plus" @click="handleAddAppClick">添加产品</el-button>
  
          <jt-table
              stripe
              :data="dataList"
              :header-cell-style="{ background: '#e8eaec', color: '#333' }"
          >
              <el-table-column
                  min-width="180"
                  :prop="item.name"
                  v-for="(item, index) in column"
                  :key="index"
                  :fixed="index === 0 ? true : false"
                  >
              >
                  <template v-slot:header>
                      {{item.display_name}}
                      <el-tooltip v-if="item.name === 'is_auth'"  effect="dark" placement="top">
                          <div slot="content">
                              1、未认证：未经过媒体认证，无法与媒体基础信息关联，准确性无法确认。
                              <br/>
                              2、已认证：经过媒体认证的产品信息，可与媒体基础信息相关联，准确性经过媒体确认。
                              <br/>
                              3、基础信息指该产品创建的计划、广告组、广告等基建信息。在媒体搭建广告并且聚投获取到后会自动关联认证。
                          </div>
                          <i class="el-icon-question"></i>
                      </el-tooltip>
                  </template>
                  <template slot-scope="scope" >
                      <div v-if="item.name === 'is_auth'">
                          <span v-if="scope.row.is_auth==='0'" style="color: #D9001B">未认证</span>
                          <span v-if="scope.row.is_auth==='1'" style="color: #63A103" >已认证</span>
                      </div>
                      <div v-else-if="item.name === 'customer_id'">
                          <template v-if="scope.row.customer_id.length>0">
                                  <el-tooltip class="item" effect="dark" :content="scope.row.customer_list_str" placement="top-start">
                                      <div class="ellipsis">{{scope.row.customer_list_str_t}}</div>
                                  </el-tooltip>
                              </template>
                          <template v-else>
                              -
                          </template>
                      </div>
                      <span v-else>{{scope.row[item.name]}}</span>
                  </template>
  
              </el-table-column>
              <el-table-column
                  prop="date"
                  label="操作"
                  width="60"
              >
                  <template slot-scope="{ row }">
                      <el-button v-if="pageFuncNames.includes('edit_app')"  type="text" size="small" @click="handleEditClick(row)">编辑</el-button>
                      <span v-else>-</span>
                  </template>
              </el-table-column>
          </jt-table>
           <el-pagination 
              class="tar mt20 pb20" 
              @size-change="handleSizeChange" 
              @current-change="handleCurrentChange"
              :current-page="pageNum" 
              :page-sizes="[30, 50, 100, 300]" 
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper" 
              :total="total"
          />
      </div>
    </div>
</template>
  
  <script>
  import CustomInput from '@/components/CustomInput'
  import { addAppModal, editAppModal, errDataTipModal } from '../modal'
  import { batchSelectModal } from '@/components/modal'
  import { appEntrySearchListApi, appEntryListApi, appEntryBatchAddApi, appEntryEditApi, getAppEntryGetFiled, getAppEntryField } from '@/api'
  import { cleanObj  } from '@/utils'
  import MullineEllips from '@/components/MullineEllips'
  import { Cascader, Select } from '@/views/mixins/ele';
  export default {
      name: 'ListPage',
      props: [ 'pageFuncNames' ],
      mixins: [ 
          Cascader({ option: 'creatorDepOptions',  value: 'formData.creatorDep', ref: 'cascader' }),
          Select({ ref: 'select',  list: 'resultDataList' }),
      ],
      components: {
          CustomInput,
          MullineEllips,
      },
      data() {
          return {
              dictData: {},
              genTypeList: [
                  { label: '推广名称', value: 'subproject_name' },
                  { label: '推广ID', value: 'subproject_id' },
                  { label: '推广内容', value: 'subproject_content' },
              ],
              resultDataList: [],
              formData: {
                  genType: 'subproject_name',//下拉类型
                  resultData: [],//下来选择的数据
                  appType: null,//产品类型
                  packageType: null,//包体类型
                  gameType: null,//游戏分类
                  platId: null,//媒体
                  auth: null,//认证情况
                  ascription: null,//归属客户
                  creator: null,//创建人
                  creatorDep: null,//创建人部门
                  date: null,//创建人部门
                  other:{}
              },
              pageSize: 30,
              pageNum: 1,
              total: 0,
              loading: false,
              dataList: [],
              searchLoading: false,
              creatorKeyWord: '',
              column:[],
              formList: []
          }
      },
      computed: {
          filterCreatorList() {
              return (this.dictData.creator || []).filter(v=> {
                  return v.label.indexOf(this.creatorKeyWord)>-1
              })
          },
          creatorDepOptions() {
              const deps =  this.dictData.creator_department || [];
              const resetData = (function resetData(list = deps) {
                  return list.map(v=> {
                      const item = {
                          ...v,
                          value: v.id,
                          label: v.name
                      };
                      if (v.children&&v.children.length) {
                          item.children = resetData(v.children)
                      }
                      return item;
                  })
              })();
              if (resetData.length) {
                  // return [{"value":"all","label":"全选"},{"id":"1","name":"AUC","children":[{"id":"12","name":"超级管理员","value":"12","label":"超级管理员"}, {"id":"123","name":"超级管理员","value":"122","label":"超级管理员1"}],"value":"1","label":"AUC"},{"id":"483","name":"产品部","children":[{"id":"491","name":"业务产品组","value":"491","label":"业务产品组"}],"value":"483","label":"产品部"}]
                  return [
                      {
                          value: 'all',
                          label: '全选',
                      },
                      ...resetData
                  ];
              }else {
                  return []
              }
             
          }
      },
      created() {
          if(this.$route?.query && this.$route.query.type == 'subproject_id' && this.$route.query.ids) {
              this.formData.genType = 'subproject_id';
              this.formData.resultData = this.$route.query.ids.split(',');
          }
          this.getFormConfig()
          this.getDictList();
          this.getTableColumn()
          this.getList()
          this.appEntrySearchList()
      },
      methods: {
          handleFilterMethod(data) {
              this.creatorKeyWord = data
          },
          handleAllCreator() {
              this.formData.creator =
              [...new Set([
                  ...this.filterCreatorList.map(v=>v.value), 
                  ...this.formData.creator
              ])]
          },
          handleAllPackageType() {
              this.formData.packageType =
              [...new Set([
                  ...this.dictData.package_type.map(v=>v.value), 
                  ...this.formData.packageType
              ])]
          },
          // 编辑
          handleEditClick(row) {
              if (row.is_auth==='1') {
                  this.$message.error('已认证不可编辑，请前往标签管理或客户产品管理修改相关信息');
                  return;
              }
              const onSubmit = async ()=> {
                  this.getList()
                  vm.close()
              }
              const { vm } = editAppModal({
                  props: {
                      appData: row
                  },
                  cbs: {
                      onSubmit
                  }
              })
          },
          // 添加产品
          handleAddAppClick() {
              const onSubmit = async (data, cb) => {
                  try {
                      await appEntryBatchAddApi(data);
                      vmadd.close()
                      this.$message.success('添加成功')
                      this.handleCurrentChange(1)
                  } catch (error) {
                      if (error.data.error.length>0) {
                          const callback = (arr)=> {
                            console.log('callback', vmadd.$refs)
                              const list = data.app_info.filter((v,i)=> {
                                  return !arr.includes(i+1)
                              });
                              vmadd.$refs.componentVm.del(arr)
                              if (list.length>0) {
                                  cb(true)
                                  vm.close()
                                  onSubmit({...data, app_info: list}, cb)
                                  
                              }else {
                                  vm.close()
                                  this.$message.error('请重新复制新的数据，当前数据已全部存在')
                              }
                          }
                          const { vm } = errDataTipModal({
                              width: '800px',
                              props: {
                                  title: error.info,
                                  list: error.data.error.map(v=> {
                                      return {
                                          tip: v.error_msg,
                                          error_num: v.error_num,
                                          index: v.error_num
                                      }
                                  }),
                                  authList: [],
                                  entryList: [],
                                  remove: data.add_type ==='2' && !!error.remove,
                                  hasNum: data.add_type ==='2'
                              },
                              cbs: {
                                  onSubmit: callback
                              }
                          })
                      }else {
                        const callback_error = (arr) => {
                            const list = data.app_info.filter((v, i) => {
                                return !arr.includes(i + 1)
                            });
                            console.log('callback1', vmadd.$refs)
                            vmadd.$refs.componentVm.del(arr)
                            if (list.length > 0) {
                                cb(true)
                                vm_error.close()
                                onSubmit({ ...data, app_info: list }, cb)

                            } else {
                                vm_error.close()
                                this.$message.error('请重新复制新的数据，当前数据已全部存在')
                            }
                        }
                        const { vm: vm_error } = errDataTipModal({
                            width: '800px',
                            props: {
                                title: error.info,
                                list: [
                                    {
                                        tip: '',
                                        error_num: error.data.err_list.error_num,
                                        index: error.data.err_list.error_num
                                    }
                                ],
                                authList: error.data.err_list.auth_err || [],
                                entryList: error.data.err_list.entry_err || [],
                                remove: data.add_type === '2' && !!error.remove,
                                hasNum: data.add_type === '2'
                            },
                            cbs: {
                                onSubmit: callback_error
                            }
                        })
                      }
                  }finally {
                      cb()
                  }
              }
              
              const { vm:vmadd } = addAppModal({
                  props: {
                     
                  },
                  cbs: {
                      onSubmit
                  }
              })
          },
          handleSizeChange(pageSize) {
              this.pageSize = pageSize;
              this.pageNum = 1;
              this.getList()
          },
          handleCurrentChange(pageNum) {
              this.pageNum = pageNum;
              this.getList()
          },
          // 下拉检索
          async appEntrySearchList(search, p ={}, cb) {
              try {
                  const { genType } = this.formData
                  const params = {
                      search_type: [ genType ],
                      search,
                      ...p
                  };
                  this.searchLoading = true
                  const { data } = await appEntrySearchListApi(cleanObj(params));
                  const list = data[genType].list;
                  const errList = data[genType].err_list;
                  if ( params.batch_search) {
                       cb(errList, ()=> {
                          const ids = list.map(v=>v.id)
                          this.resultDataList =
                          [
                              ...this.resultDataList.filter(v=>this.formData.resultData.includes(v.value)&&!ids.includes(v.value)),
                              ...list.map(v=> {
                                  return {
                                      ...v,
                                      value: v.id,
                                      label: v.name
                                  }
                              })
                          ];
                          this.formData.resultData = [...new Set([ ...this.formData.resultData, ...ids ])];
                      })
                  }else {
                      this.resultDataList = list.map(v=> {
                          return {
                              ...v,
                              value: v.id,
                              label: v.name
                          }
                      })
                  }
              } catch (error) {
                  this.$message.warning(error.info)
              } finally {
                   this.searchLoading = false
              }
          },
          // 获取form表单配置
          getFormConfig() {
              getAppEntryField().then(res=>{
                  this.formList = res.data
                  this.formList.forEach(v=> {
                      this.$set(this.formData.other, v.name, [])
                  })
                  
              },error=>{
                  this.$message.error(error.info)
              })
          },
          // 获取检索的字典
          async getDictList() {
              const keys = [ 'app_type', 'package_type', 'game_classify', 'plat_id', 'is_auth', 'creator', 'creator_department' ];
              this.dictData = keys.reduce((pre, item)=> {
                  pre[item] = [];
                  return pre;
              }, {})
              const params = {
                  search_type: keys
              };
              const { data } = await appEntrySearchListApi(params);
              keys.forEach(v=> {
                  const list = (data[v]?.list || []).map(v=> {
                      return {
                          ...v,
                          value: v.id,
                          label: v.name
                      }
                  });
                  this.dictData[v] = list
              });
          },
          // 列表
          async getTableColumn() {
              const { data } = await getAppEntryGetFiled({type: 'column'});
              this.column = data
              console.log('column', data)
          },
          async getList() {
              try {
                  const { 
                      genType, resultData, appType, packageType,gameType,platId,
                      auth,ascription,creator,creatorDep,date
                  } = this.formData;
                  const params = {
                      ...this.formData,
                      [genType]: resultData,
                      app_type: appType,
                      package_type: packageType,
                      game_classify: gameType,
                      plat_id: platId,
                      is_auth: auth,
                      company_name: ascription,
                      creator,
                      creator_department: (creatorDep || []).map(v=> v && v.join('-')).filter(v=>v!=='all'),
                      range_time: date&&date.join('/'), 
                      rn: this.pageSize,
                      pn: this.pageNum
                  };
                  this.loading = true
                  const result = await appEntryListApi(cleanObj(params));
                  const { list, totalCnt } = result.data
                  this.dataList = list.map(v=> {
                      return {
                          ...v,
                          customer_list_str: v.customer_id.map((v, i)=> {
                              return `${v.company_name}`
                          }).join('、'),
                          customer_list_str_t: `${v.customer_id.length}：${v.customer_id.map(v=>v.company_name).join('、')}`,
                          subproject_id: v.subproject_id || '-',
                          subproject_content: v.subproject_content || '-',
                          subproject_name: v.subproject_name || '-',
                          app_type_name: v.app_type_name || '-'
                      }
                  });
                  this.total = totalCnt
              } catch (error) {
                  console.log(error);
                  this.$message.error(error.info)
              }finally {
                  this.loading = false
              }
          },
          handleGenAppendClick() {
              const onSubmit = (data, callback)=> {
                  this.appEntrySearchList(
                      '', 
                      {
                          batch_search: data,
                      }, 
                      (errs, cb)=> {
                          callback();
                          if (errs.length) {
                              delErrList({
                                  tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                  list: errs,
                                  onOk: ()=> {
                                      cb();
                                      vm.close();
                                  }
                              })
                          }else {
                               cb();
                               vm.close();      
                          }
                      }
                  )
              }
              const { vm, delErrList } = batchSelectModal({
                 title: '批量添加',
                 props: {
                      tip: '输入或粘贴名称或ID，每行一个',
                      hasLoading: true
                  },
                  cbs: {
                      onSubmit
                  }
              })
          },
          handleSelectAll(list) {
              const data = [...(this.formData.resultData || [])];
              data.push(...list.map(v=>v.value));
              // 去重 赋值
              this.formData.resultData = [ ...new Set(data)]
          },
          handleSelectAllNew(list, name) {
              const data = [...(this.formData.other[name] || [])];
              data.push(...list.map(v=>v.value));
              // 去重 赋值
              this.formData.other[name] = [ ...new Set(data)]
          },
          handleClear() {
              this.$refs['form'].resetFields()
              this.formData.other
              let other_keys = Object.keys(this.formData.other)
              other_keys.forEach(v=> {
                  this.formData.other[v] = []
              })
              this.$nextTick(()=>{
                  this.getList()
              })
          }
      },
      
  }
  </script>
  
  <style lang="scss" scoped>
  .opts {
      border-top: 1px solid #ccc;
      padding-top: 14px;
  }
  .form-box {
      background: #ffffff;
      padding: 10px 10px;
      border-radius: 4px;
      &::v-deep {
          .el-form-item {
              margin-bottom: 10px;
          }
      }
  }
  .table-context {
      background-color: #fff;
      margin-top: 12px;
      border-radius: 4px;
      padding-top: 12px;
  }
  </style>
  